var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_ROUTES = 'api/routes';
const GET_STORE_ROUTES_BY_ID = 'api/stores/:id/routes';
//@deprecated
export const createRoute = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(GET_SET_ROUTES, data, config);
        }
        catch (error) {
            console.error('Error fetching createRoute:', error);
            throw error;
        }
    });
};
export const createRouteV2 = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const { storeId, storeIds, driver, orders } = data;
            if (storeIds) {
                return yield this.axiosInstance.post(GET_SET_ROUTES, {
                    storeIds,
                    driver,
                    orders,
                }, config);
            }
            return yield this.axiosInstance.post(GET_STORE_ROUTES_BY_ID.replace(':id', storeId), {
                driver,
                orders,
            }, config);
        }
        catch (error) {
            console.error('Error fetching createRouteV2:', error);
            throw error;
        }
    });
};
export const startRoute = function (routeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ROUTES}/${routeId}/start`, {}, config);
        }
        catch (error) {
            console.error('Error fetching startRoute:', error);
            throw error;
        }
    });
};
